import { useQuery } from 'react-query'
import { getAttendanceGraph } from '../api-reports'
import { useReports } from '../Context/ReportsContext'

export const useAttendance = () => {
    const { reportQuery, enabled, staleTime } = useReports()
    const { courseId, cohorts, ...restQuery } = reportQuery
    const queryKey = [
        courseId,
        'Reports',
        'Attendances',
        'Graph',
        `Cohorts: ${cohorts?.join()}`,
        restQuery,
    ]
    const { data: attendances, ...rest } = useQuery(
        queryKey,
        () => getAttendanceGraph(reportQuery),
        { enabled, staleTime }
    )

    return { attendances, ...rest }
}
